module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Eye of Scota")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Serena Yates")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("Dalriata: Book One")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("In 845 a group of Gaels fleeing the Vikings stumbled through the mystic Eye of Scota and found safety on a planet they named Dalriata. Seven centuries later, the arrival of the Crìosdaidh religion changed everything. Fugitives stopped appearing, and the newly established Council of Priests used the energy of Slànach Stones to enforce their religious laws. But by 2500 the Stones’ power is dwindling. The High Priest is desperate—none of the warriors sent to find more Stones have returned.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Cináed MacAlpin, a young healer priest, is chosen to undertake another attempt. He hopes that new Stones will reduce the pressure to heal only those deemed worthy by the priests. But his task is not easy. Cináed must travel to the land of Bunádh and find the Eye that is the source of the Stones. Once there he meets Tadeo Banderas, a spaceship captain exploring the newest Earth-like planet discovered by the Solar Exploration Fleet. Cináed and Tadeo soon find out that the spark of energy between them may hold the key to Dalriata’s future.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 57
// module chunks = 0